import React from 'react';
import { colors } from '@styleseat/brand';
import { View } from 'react-native';
import { ReaderStatus } from '../TapToPayContext';
import { HeaderText, Stack } from '../../../../ui';
import LoadingDots from '../LoadingDots';

const ignoreStatus = [ReaderStatus.Done];

const loadingStatus = [
  ReaderStatus.Ready,
  ReaderStatus.Connecting,
  ReaderStatus.Initializing,
  ReaderStatus.ProcessingPayment,
];

const message = new Map([
  [
    ReaderStatus.Ready,
    'Preparing',
  ],
  [
    ReaderStatus.Connecting,
    'Connecting',
  ],
  [
    ReaderStatus.Initializing,
    'Initializing',
  ],
  [
    ReaderStatus.ProcessingPayment,
    'Processing payment',
  ],
]);

export type ReaderStatusIndicatorProps = {
  status: ReaderStatus;
  progress?: number;
  testID?: string;
};

export const ReaderStatusIndicator: React.FC<ReaderStatusIndicatorProps> = ({
  status,
  progress = 0,
  testID = 'tap-to-pay-connection-status',
}) => {
  if (ignoreStatus.includes(status)) {
    return null;
  }

  if (loadingStatus.includes(status)) {
    return (
      <Stack alignItems="center" space={16} testID={`${testID}-pending`}>
        <HeaderText level={3} color={colors.ash}>
          {message.get(status)}
          {status === ReaderStatus.Connecting && ` (${(progress * 100).toFixed(0)}%)`}
        </HeaderText>
        {/* TODO: Replace this View with a UI component (Box, Inline, etc) */}
        <View style={{ width: '70px' }}>
          <LoadingDots testIdPrefix={testID} />
        </View>
      </Stack>
    );
  }

  return (
    <HeaderText
      level={3}
      textAlign="center"
      color={colors.whiteWash}
      testID={`${testID}-success`}
    >
      Tap anywhere to continue
    </HeaderText>
  );
};
